import { Identifiable, SecondaryCriteria } from "@planzone/dto";

type SecondaryCriteriaTemplate = Identifiable<SecondaryCriteria>[];

const secondaryCriteriaTemplate: SecondaryCriteriaTemplate = [];

export type { SecondaryCriteriaTemplate };

export { secondaryCriteriaTemplate };
